import React, { useContext } from "react";

import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import { Checkbox, ListItemText } from "@material-ui/core";
import { WhatsAppsContext } from "../../context/WhatsApp/WhatsAppsContext";

const TicketsWhatsappSelect = ({
	selectedWhatsappIds = [],
	onChange,
}) => {
	const { whatsApps } = useContext(WhatsAppsContext);

	const handleChange = e => {
		onChange(e.target.value);
	};

	return (
		<div style={{ width: 120, marginTop: -4 }}>
			<FormControl fullWidth margin="dense">
				<Select
					multiple
					displayEmpty
					variant="outlined"
					value={selectedWhatsappIds}
					onChange={handleChange}
					MenuProps={{
						anchorOrigin: {
							vertical: "bottom",
							horizontal: "left",
						},
						transformOrigin: {
							vertical: "top",
							horizontal: "left",
						},
						getContentAnchorEl: null,
					}}
					renderValue={() => "Conexión"}
				>
					{whatsApps?.length > 0 &&
						whatsApps.map(whatsapp => (
							<MenuItem dense key={whatsapp.id} value={whatsapp.id}>
								<Checkbox
									size="small"
									color="primary"
									checked={selectedWhatsappIds.indexOf(whatsapp.id) > -1}
								/>
								<ListItemText primary={whatsapp.name} />
							</MenuItem>
						))}
				</Select>
			</FormControl>
		</div>
	);
};

export default TicketsWhatsappSelect;
